import Portfolio from '../components/portfolio2';

const PortfolioPage = () => {
    return (
        <div className="pt-20">
            <Portfolio />
        </div>
    );
};

export default PortfolioPage;